<template>
  <section class="banner-section" :class="ready ? 'render-ready' : 'render-locked'">
    <div ref="bannerSwiper" class="swiper-container banner-swiper" :style="crc.container">
      <div class="swiper-wrapper">
        <div v-for="(banner, idx) in banners" :key="idx" class="swiper-slide banner-slide">
          <img
            :src="banner.url"
            :alt="'Banner'"
            class="banner-img"
            :style="getImageStyle()"
          />
          <!-- CRC-driven overlay -->
          <div v-if="crc.overlay.enabled" class="banner-overlay" :style="getOverlayStyle()"></div>
        </div>
      </div>
      <div class="swiper-pagination banner-pagination"></div>
    </div>
  </section>
</template>

<script>
import Swiper from 'swiper'
import { fetchHomeData } from '@/api'
import { BannerCRC, applyBannerCRC } from '@/contracts/banner.crc'
import { initSynced } from '@/sync/swiper-sync'

export default {
  name: 'Banner',
  data() {
    return {
      banners: [],
      ready: false,
      bannerSwiper: null,
      crc: BannerCRC,
    }
  },
  methods: {
    getImageStyle() {
      const applied = applyBannerCRC()
      return applied.style
    },
    getOverlayStyle() {
      const applied = applyBannerCRC()
      return applied.overlayStyle
    },
  },
  async mounted() {
    const data = await fetchHomeData()
    this.banners = data.banners
    await this.$nextTick()

    this.bannerSwiper = initSynced(Swiper, this.$refs.bannerSwiper, this.crc.swiper)

    this.ready = true
  }
}
</script>

<style scoped>
.banner-section { margin: 0 10px var(--s-5); }
.banner-swiper { border-radius: var(--radius-xl); overflow: hidden; }
.banner-slide { position: relative; }
.banner-img { width: 100%; display: block; }
.banner-overlay { border-radius: var(--radius-xl); }
.banner-pagination { position: absolute; bottom: var(--s-3); left: 50%; transform: translateX(-50%); display: flex; gap: 6px; z-index: 5; }
:deep(.swiper-pagination-bullet) { width: 6px; height: 6px; background: rgba(255,255,255,0.4); opacity: 1; border-radius: 3px; }
:deep(.swiper-pagination-bullet-active) { background: #fff; width: 16px; }
</style>
